import { useParams } from "react-router"
import "./css/Share.css"
import { useEffect, useState } from "react"
import axios from "axios"
import api from "../config/backend"
import CustomisedForm from "../components/CustomisedForm"
import { SpinnerCircular } from "spinners-react"

const Share = () => {
    const [formdata, setFormdata] = useState(undefined)

    const { id } = useParams()

    const fetchPublic = async () => {
        const { data, status } = await axios.post(`${api}/Form/fetch-public`, { hash: id })

        if (data.success) {
            setFormdata(data.form)
        } else {
            console.log({ data })
        }
    }

    useEffect(() => {
        if (id) {
            fetchPublic()
        }
    }, [id])

    console.log({formdata})

    return (
        <div className="_4ech">
            {formdata ? <CustomisedForm form={formdata} submitEnabled={true} /> : <SpinnerCircular />}
        </div>
    )
}

export default Share
